export let CMS_PERM = {
    'edit' : {perm:'edit'},
    'document' : {perm:'admindashboard.cms'},
    'environment' : {perm:'admindashboard.cms'},
    'useCase' : {perm:'admindashboard.cms'},
    'version' : {perm:'admindashboard.cms'},
    'new' : {perm:'admindashboard.cms'},
    'versions' : {perm:'admindashboard.cms'},
    'upgrade' : {perm:'admindashboard.upgradedevice'},
    'care' : {perm:'admindashboard.upgradedevice'},
    'efota' : {perm:'admindashboard.upgradedevice'},
    'home' : {perm:'admindashboard.upgradedevice'},
    'efotareports' : {perm:'admindashboard.upgradedevice'},
    'reportupload' : {perm:'admindashboard.upgradedevice'},
    'reportdetails' : {perm:'admindashboard.upgradedevice'},
    'efotadetails' : {perm:'admindashboard.upgradedevice'},
    'dmpWhitelistFans' : {perm:'admindashboard.cms'}
}
